import React, { useEffect, useState, useRef } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "./sidebardata";
import Chatbot from '../Bot/Chatbot';
import { ChevronLeft, User, Grid, Layers, Bookmark, RefreshCw, Calendar, Clock, Activity, Sun, DollarSign, Camera, MapPin, Layout, Box, Briefcase, Bell, FileText, Users, Award, TrendingUp, FileMinus, FilePlus, List, Settings, Clipboard, BarChart2, Home } from 'react-feather';
import { FaUsers, FaBriefcase, FaCalendarAlt, FaPlaneArrival, FaPlaneDeparture, FaBed, FaDoorOpen } from 'react-icons/fa';

const Sidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = useTranslation();
  const [sidebarData, setSidebarData] = useState(SidebarData);
  const [isSideMenu, setIsSideMenu] = useState("feedback-settings");
  const profileTabRef = useRef(null);
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  const toggleChatbot = (e) => {
    setIsChatbotOpen((prev) => !prev);
  };

  useEffect(() => {
    if (profileTabRef.current) {
      profileTabRef.current.click();
    }
  }, []);

  useEffect(() => {
    const menuMapping = {
      '/hospitality': 'employee',
      '/departments': 'employee',
      '/designations': 'employee',
      '/profile': 'profile',
      '/leave-types': 'employee',
      '/holidays': 'employee',
      '/shift-list': 'employee',
      '/overtime': 'employee',
      '/announcements': 'employee',
      '/leaves-employee': 'leaves',
      '/adminleaves': 'leaves',
      '/leave-applications': 'leaves',
      '/leaves-balance': 'leaves',
      '/leave-settings': 'leaves',
      '/attendance-weekly': 'attendance',
      '/attendance-daily': 'attendance',
      '/adminattendance': 'attendance',
      '/attendance-employee': 'attendance',
      '/payroll-overview': 'payroll-overview',
      '/salary': 'payroll-overview',
      '/payroll-items': 'payroll-overview',
      '/run-payroll': 'payroll-overview',
      '/payroll-settings': 'payroll-overview',
      '/payroll-history': 'payroll-overview',
      '/payroll-reports': 'payroll-overview',
      '/devices': 'devices',
      '/deviceslog': 'devices',
      '/device-users': 'devices',
      '/manage-locations': 'company-settings',
      '/feedback/feedback-setting': 'feedback',
      '/feedback/feedback-responses': 'feedback',
      '/property-configuration': 'property-configuration',
    };

    const matchedMenu = Object.keys(menuMapping)
      .sort((a, b) => b.length - a.length)
      .find(route => pathname.startsWith(route)) || "";
    
    if (matchedMenu) {
      toggleSidebar(menuMapping[matchedMenu]);
    } else {
      toggleSidebar('feedback');
    }
  }, [pathname]);

  useEffect(() => {
    if (!isSideMenu) {
      toggleSidebar('employee-dashboard');
    }
  }, []);

  const expandSubMenus = (menu) => {
    const updatedAdminSidebar = sidebarData.map((section) => {
      const updatedSection = { ...section };
      updatedSection.menu = section.menu.map((menuItem) =>
        menu.menuValue !== menuItem.menuValue
          ? { ...menuItem, showSubRoute: false }
          : { ...menuItem, showSubRoute: true }
      );
      return updatedSection;
    });
    setSidebarData(updatedAdminSidebar);
  };

  const toggleSidebar = (value) => {
    setIsSideMenu(value);
  };

  const isActive = (routes) => {
    const currentPath = window.location.pathname.replace(/\/$/, "");
    const routeArray = Array.isArray(routes) ? routes : [routes];
    return routeArray.some(path => currentPath === path.replace(/\/$/, ""));
  };

  return (
    <>
      <div className="sidebar">
 
        <div className="sidebar-inner" >
          <div className="sidebar sidebar-twocol">
   
            <div className="sidebar-right"  style={{ 
        position: 'absolute', // or 'fixed' depending on desired behavior
        left: '0px', 
        width: "100%",
      }}
    >
              <div className="tab-content-horizontal" id="v-pills-tabContent">
                {isSideMenu === "dashboard" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li>
                          <Link
                            className={isActive(['/employee-dashboard']) ? "active" : ""}
                            to="/employee-dashboard"
                          >
                            <Home size={16} style={{ marginRight: '4px' }} /> {t("My Dashboard")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
  
   
{isSideMenu === "feedback" && (
<div className="tab-pane fade active show">
  <div className="submenu-horizontal">
    <ul>
      <li>
        <Link
          className={isActive(['/channel-manager']) ? "active" : ""}
          to="/channel-manager"
        >
          <Home size={16} className="icon-with-margin" /> {t("Dashboard")}
        </Link>
      </li>

            <li>
              <Link
                className={isActive(['/channel-manager/property/']) ? "active" : ""}
                to="/channel-manager/property/"
              >
                <MapPin size={16} className="icon-with-margin" /> {t("Property")}
              </Link>
            </li>
      <li>
        <Link
          className={isActive(['/channel-manager/list-channels']) ? "active" : ""}
          to="/channel-manager/list-channels"
        >
          <Users size={16} className="icon-with-margin" /> {t("Connected Channels")}
        </Link>
      </li>

      <li>
        <Link
          className={isActive(['/channel-manager/ari/']) ? "active" : ""}
          to="/channel-manager/ari/kkkkk"
        >
          <Users size={16} className="icon-with-margin" /> {t("Rates & Availability")}
        </Link>
      </li>
      

      <li>
        <Link
          className={isActive(['/channel-manager/bookings']) ? "active" : ""}
          to="/channel-manager/bookings"
        >
          <Users size={16} className="icon-with-margin" /> {t("Bookings")}
        </Link>
      </li>
      
     

      <li>
        <Link
          className={isActive(['/channel-manager/ota-settings']) ? "active" : ""}
          to="/channel-manager/ota-settings"
        >
          <Settings size={16} className="icon-with-margin" /> {t("Settings")}
        </Link>
      </li>
      <li>
        <Link
          className={isActive(['/channel-manager/reports','/channel-manager/reports/overview']) ? "active" : ""}
          to="/channel-manager/reports"
        >
          <BarChart2 size={16} className="icon-with-margin" /> {t("Reports")}
        </Link>
      </li>
      <li>  
        <Link
          className={isActive(['channel-manager/setup']) ? "active" : ""}
          to="channel-manager/setup"
        >
          <Users size={16} className="icon-with-margin" /> {t("Integrations")}
        </Link>
      </li>
      <li>
        <Link
          className={isActive(['/channel-manager/support']) ? "active" : ""}
          to="/channel-manager/support"
        >
          <Bell size={16} className="icon-with-margin" /> {t("Support")}
        </Link>
      </li>
    </ul>
  </div>
</div>
)}
                {isSideMenu === "settings" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li><Link to="/hospitality/property-configuration">{t("Account Settings")}</Link></li>
                        <li><Link to="/privacy-settings">{t("Privacy Settings")}</Link></li>
                        <li><Link to="/notification-settings">{t("Notification Settings")}</Link></li>
                        <li><Link to="/theme-settings">{t("Theme Settings")}</Link></li>
                      </ul>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
      <Chatbot isOpen={isChatbotOpen} toggleChatbot={toggleChatbot} />
    </>
  );
};

export default Sidebar;